export function isTimestamp(nameArr: string): boolean {
  const parsed: number = parseFloat(nameArr);
  return !Number.isNaN(parsed) && Number.isFinite(parsed) && /^\d+\.?\d+$/.test(nameArr);
}
